// Import Dependencies
import { createBrowserRouter } from "react-router";

// Local Imports
import Root from "@layout/Root";
import RootErrorBoundary from "app/presentation/pages/errors/RootErrorBoundary";
import { SplashScreen } from "app/presentation/components/template/SplashScreen";
import { protectedRoutes } from "./protected";
import { ghostRoutes } from "./ghost";
import { publicRoutes } from "./public";

// ----------------------------------------------------------------------

const router = createBrowserRouter([
  {
    id: "root",
    Component: Root,
    hydrateFallbackElement: <SplashScreen />,
    ErrorBoundary: RootErrorBoundary,
    children: [protectedRoutes, ghostRoutes, publicRoutes],
  },
]);

export default router;
